<lex-case-analytics-item [noDataInCase]="noDataInCase$">
    @if (periodSummary === null) {
        <div card-header-content-primary *ngIf="!shouldShowLoader" [@appear]>
            <div>Collection Summary</div>
            <div>Documents grouped by <b>master date</b></div>
        </div>
    }
    @else {
        @if (periodSummary.masterDate !== 'Undated') {
            <div card-header-content-primary *ngIf="!shouldShowLoader" [@appear]>
                <div>{{periodSummary.masterDate | date:'MMMM, y'}}</div>
                <div>{{periodSummary.docCount | number}}</div>
                <div>
                    Document<span *ngIf="periodSummary.docCount !== 1">s</span>
                    collected for this month
                </div>
            </div>
        }
        @else {
            <div card-header-content-primary *ngIf="!shouldShowLoader" [@appear]>
                <div>Undated</div>
                <div>{{periodSummary.docCount | number}}</div>
                <div>
                    Document<span *ngIf="periodSummary.docCount !== 1">s</span>
                    not grouped to any master date
                </div>
            </div>
        }

    }
    <div card-body-content-chart *ngIf="collectionChartData.datasets.length > 0" [ngClass]="{'loading': shouldShowLoader === true}">
        <canvas baseChart
        [data]="collectionChartData"
        [options]="collectionChartOptions"
        [plugins]="ngChartPlugins"
        [type]="collectionChartType"
        (chartHover)="displayPeriodSummary($event)"
        aria-label="Line chart showing the number of documents collected in a time period per custodian." role="img">
        </canvas>
    </div>
    <div card-body-content-chart *ngIf="shouldShowLoader" style="display: flex; align-items: center; justify-content: center;">
      <i card-body-loading-icon class="fa-light fa-chart-waterfall fa-fade" style="font-size: 19.2vh;"></i>
    </div>
    <div card-body-content-legend></div>
    <div card-body-no-content></div>
</lex-case-analytics-item>
